import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { CatalogRow } from '@app/services/catalogo/models';
import { NzTableSortOrder } from 'ng-zorro-antd/table';

export type RowActionType = 'assign' | 'details' | 'history'| 'schedule'| 'import';
@Component({ standalone: false, selector: 'app-catalog-table',
  templateUrl: './catalog-table.component.html',
  styleUrls: ['./catalog-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CatalogTableComponent {

  @Input() rows: CatalogRow[] = [];
  @Input() loading = true;
  @Input() pageIndex = 1;
  @Input() pageSize = 10;
  @Input() densityClass = 'tbl--normal';
  @Input() sortOrderOld: NzTableSortOrder = null;
  @Input() sortKey: string | null = null;
  @Input() sortOrder: NzTableSortOrder | null = null;
  @Input() scheduleVisibleRow: CatalogRow | null = null;

  // Config de visibilidad de columnas
  @Input() visibleCols!: {
    name: boolean;
    provider: boolean;
    status: boolean;
    typeCatalog: boolean;
    receivedAt: boolean;
    publishedAt: boolean;
    effectiveDate?: boolean
    importDate?: boolean
    importPfDate?: boolean
    releaseDate?: boolean
    rate: boolean;
    assignments: boolean;
    actions: boolean;
  };

  // Plantillas de popover (proveídas por el padre)
  @Input() assignTpl!: TemplateRef<any>;
  @Input() scheduleTpl!: TemplateRef<any>;

  // Etiquetas de estado
  @Input() stateLabel!: (s: any) => string;
  @Input() stateClass!: (s: any) => any;

  // Eventos hacia el padre
  @Output() sortChange = new EventEmitter<{ key: string; order: NzTableSortOrder | null }>();

  @Output() pageIndexChange = new EventEmitter<number>();
  @Output() pageSizeChange = new EventEmitter<number>();

  @Output() clickRefresh = new EventEmitter<CatalogRow>();
  @Output() clickHistory = new EventEmitter<CatalogRow>()
  @Output() actionClicked = new EventEmitter<{ type: RowActionType; row: any; other: Record<string, any> }>();

  trackByRow = (index: number, row: CatalogRow): string | number => row?.id ?? index;


  onRefresh(): void {
    this.clickRefresh.emit();
  }
  onSort = (key: string, order: NzTableSortOrder | null): void =>
    this.sortChange.emit({ key, order });

  onAction = (type: RowActionType, row: any, other: Record<string, any> = {} ): void => this.actionClicked.emit({ type, row, other });


  private isDateColumn(key: string): boolean {
    return [
      'receivedAt',
      'publishedAt',
      'effectiveDate',
      'importDate',
      'importPfDate',
      'releaseDate'
    ].includes(key);
  }

  // >>> fechas en formato dd/MM/yyyy (por ejemplo "2/10/2025")




}
